import React from "react";
import { Box, TextField } from "@mui/material/";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "./styles";
import { strings } from "../../../../common/i18n";
import MatReactTable from "../../../../common/components/MaterialReactTable";
import useColumnsRows from "./useColumnsRows";
import Dialog from "./Dialog";

/**
 * Audit Branches Component
 */


export default () => {
    const {
        loading,
        rows,
        columns,
        isModalShown,
        onAuditNameSave,
        onNameChange,
        amendedAudit,
        onClose
    } = useColumnsRows();

    // A name of only spaces looks blank in every list and cannot be searched
    // for, so treat it exactly like an empty one.
    const isNameEmpty = amendedAudit.name.trim() === "";

    if (loading)
        return (
            <Box sx={styles.loading}>
                <CircularProgress />
            </Box>
        );

    return (
        <>
            <MatReactTable
                persistKey="auditCreateAuditors"
                columns={columns}
                data={rows}
                loading={loading}
                noRowsMessage={strings("messages.noAssets")}
            />
            <Dialog
                isModalShown={isModalShown}
                onSave={onAuditNameSave}
                onClose={onClose}
                disabledSave={isNameEmpty}
            >
                <TextField
                    id="new-audit-name-id"
                    variant="standard"
                    defaultValue={amendedAudit.name}
                    fullWidth
                    error={isNameEmpty}
                    label={strings("auditName")}
                    onChange={(e) => onNameChange(e)}
                    sx={styles.DialogContent}
                    helperText={
                        isNameEmpty
                            ? strings("messages.emptyAuditName")
                            : ""
                    }
                />
            </Dialog>
        </>
    );
};
